import { render } from "./pie.vue?vue&type=template&id=b9f4d43c&ts=true"
import script from "./pie.vue?vue&type=script&setup=true&lang=ts"
export * from "./pie.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/pie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9f4d43c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9f4d43c', __exports__)) {
    console.log('reload')
    api.reload('b9f4d43c', __exports__)
  }
  
  module.hot.accept("./pie.vue?vue&type=template&id=b9f4d43c&ts=true", () => {
    console.log('re-render')
    api.rerender('b9f4d43c', render)
  })

}


export default __exports__